import { httpFeatureFlag } from "@/api/httpFeatureFlag";

type FeatureFlagRequests = {
  get_all_targetted_feature_flags: (args?: { body?: { flag_set: string } }) => Promise<unknown>;
  get_feature_flag: (args: { searchParams: { feature_name: string } }) => Promise<unknown>;
  get_feature_flag_set: (args?: { body?: { flag_set: string } }) => Promise<unknown>;
  post_feature_flag_error: (args?: { body?: unknown }) => Promise<unknown>;
};

export const featureFlagRequests: FeatureFlagRequests = {
  get_all_targetted_feature_flags: function ({ body } = {}) {
    return httpFeatureFlag
      .post("/v1/feature_flag/private", {
        headers: { Authorization: localStorage.getItem("token") ?? "" },
        json: body,
      })
      .json<unknown>();
  },

  get_feature_flag: function ({ searchParams }) {
    return httpFeatureFlag.get("/v1/public/feature_flag", { searchParams }).json<unknown>();
  },

  get_feature_flag_set: function ({ body } = {}) {
    return httpFeatureFlag
      .post("/v1/feature_flag/public", {
        json: body,
      })
      .json<unknown>();
  },

  post_feature_flag_error: function ({ body } = {}) {
    return httpFeatureFlag
      .post("/v1/feature_flag/error", {
        headers: { Authorization: localStorage.getItem("token") ?? "" },
        json: body,
      })
      .json<unknown>();
  },
};
